// 获取文件后缀;
/** 获取文件类型后缀 */
export function getFileExtension(file?: { name: string }): string;
export function getFileExtension(fileName?: string): string;
export function getFileExtension(data?: any): string {
  if (!data) return "";
  let fileName = typeof data === "object" ? data.name : data;
  const match = fileName.match(/\.([^\.]+)$/);
  return match ? match[1].toLowerCase() : "";
}

// 根据网络地址下载文件;
export async function downloadFile(url: string, fileName: string) {
  const link = document.createElement("a");
  link.id = url;
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/** 文件大小限制 */
export enum FILE_SIZE_LIMIT {
  // 1MB
  MB_1 = 1,
  // 5MB
  MB_5 = 5,
  // 10MB
  MB_10 = 10,
  // 50MB
  MB_50 = 50,
  // 100MB
  MB_100 = 100,
  // 500MB
  MB_500 = 500,
  // 1000MB
  MB_1000 = 1000,
}

// 通用最大图片文件大小
export const MAX_IMAGE_FILE_SIZE = FILE_SIZE_LIMIT.MB_100; // MB

// 通过fetch下载文件;
export async function downloadFileWithFetch(url: string, fileName: string) {
  const response = await fetch(url);
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
}

/** 默认允许的文件类型 */
const DefaultAcceptedFileExtensions = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "svg",
  "webp",
];

/**
 * 判断文件类型是否合法
 * @param file
 * @param acceptExtensions 允许的文件类型
 */
export function checkFileExtensionValid(
  file: { name?: string },
  acceptExtensions: string[] = DefaultAcceptedFileExtensions,
  t?: any
) {
  const fileExtension = getFileExtension(file.name);
  const isFileExtSupported = acceptExtensions.some((ext) => {
    if (fileExtension.toLowerCase() === ext.toLowerCase()) return true;
    return false;
  });
  if (!isFileExtSupported) {
    useToast.error(t("upload.unsupported_file_format"));
  }
  return isFileExtSupported;
}

/**
 * 判断文件大小是否合法
 * @param file
 * @param maxSize 允许的文件最大值，以MB为单位。不传则不限制
 * @param t i18n实例
 */
export function checkFileSizeValid(
  file: { size?: number },
  maxSize?: FILE_SIZE_LIMIT | number,
  t?: any
) {
  if (!file.size) return false;
  if (!maxSize) return true;
  const maxSizeBytes = maxSize * 1024 * 1024;
  if (t && file.size > maxSizeBytes) {
    useToast.error(
      t("upload.uploaded_file_exceeds_upper_limit", {
        value: `${maxSize}MB`,
      })
    );
  }
  return file.size <= maxSizeBytes;
}
